import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/parentDirectoryId/${number | ':directoryParentId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/parentDirectoryId/:directoryParentId`;

export const URL = (workOrderId: number, directoryParentId: number): RouteDefinition => `${baseRoute}/${workOrderId}/parentDirectoryId/${directoryParentId}`;
